/*
  Cart-drawer upsell: swap the thumbnail when the colour/size dropdown changes,
  so the image always reflects the selected variant. Each <option> carries a
  data-variant-image URL (set in sections/cart-upsell.liquid). Delegated on the
  document because the upsell cards are injected into the drawer at runtime.
*/
(function () {
  document.addEventListener('change', function (e) {
    var select = e.target.closest ? e.target.closest('.cart-upsell__select') : null;
    if (!select) return;
    var option = select.options[select.selectedIndex];
    var url = option && option.getAttribute('data-variant-image');
    if (!url) return;
    var item = select.closest('.cart-upsell__item');
    var img = item && item.querySelector('.cart-upsell__image');
    if (img) img.src = url;
  });
})();
